import React, { createContext, useState, useContext, useEffect } from "react";
import {
  fetchUser,
  getAllAppointmentsByEmail,
  getAllEvents,
  getAllLocations,
  getAllMembers,
  getAllTestimonials,
} from "../backend.js"; // Import the fetchUser method

// Create Auth Context
const AuthContext = createContext();

// Custom hook to use AuthContext
export const useAuth = () => useContext(AuthContext);

// AuthProvider Component
export const UserContext = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [showRegisterComponent, setShowRegisterComponent] = useState(false);
  const [showLoginComponent, setShowLoginComponent] = useState(false);
  const [appointment, setAppointment] = useState([]);
  const [options, setOptions] = useState({
    event: [],
    member: [],
    testimonial: [],
    location: [],
  });
  const fetchOptions = async () => {
    const [events, members, testimonials, locations] = await Promise.all([
      getAllEvents(),
      getAllMembers(),
      getAllTestimonials(),
      getAllLocations(),
    ]);
    setOptions({
      event: events || [],
      member: members || [],
      testimonial: testimonials || [],
      location: locations || [],
    });
  };
  useEffect(() => {
    fetchOptions();
  }, []);

  const login = async (token) => {
    localStorage.setItem("token", token);
    setIsLoggedIn(true);
    try {
      const userData = await fetchUser(token);
      setCurrentUser(userData);
    } catch (error) {
      logout();
    }
  };
  const fetchAppointment = async () => {
    if (currentUser) {
      const response = await getAllAppointmentsByEmail(currentUser?.email);
      setAppointment(response);
    }
  };
  const openGmail = () => {
    let email = "rk@drrkvishwakarma.com";
    window.location.href = `mailto:${email}`;
  };
  const openWhatsApp = () => {
    let message = "Hello, I want help.";
    const encodedMessage = encodeURIComponent(message);
    const url = `https://wa.me/${+919918686874}?text=${encodedMessage}`;
    window.open(url, "_blank");
  };

  // Initiates a phone call to the given number
  const makeCall = () => {
    window.location.href = "tel:+919129371733";
  };
  const handleRegisterComponent = () => {
    setShowLoginComponent(false);
    setShowRegisterComponent(!showRegisterComponent);
  };
  const handleLoginComponent = () => {
    setShowRegisterComponent(false);
    setShowLoginComponent(!showLoginComponent);
  };
  const logout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    setCurrentUser(null);
    alert("Logout successfull.", currentUser?.email);
  };
  function convertGoogleDriveLinkToIframe(link) {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)\/(view|preview)/;
    const match = link.match(regex);

    if (match && match[1]) {
      const fileId = match[1];
      return `https://drive.google.com/file/d/${fileId}/preview`;
    }

    return link; // Return original link if it's not a Google Drive link
  }

  const covertDriveLinkToImage = (value) => {
    if (!value) return "";

    // Handle different Drive URL patterns
    let fileId = "";

    // Match /d/FILE_ID/ or /d/FILE_ID
    const match1 = value.match(/\/d\/([^/]+)/);
    // Match id=FILE_ID in URLs like /open?id=FILE_ID
    const match2 = value.match(/id=([^&]+)/);

    if (match1) {
      fileId = match1[1];
    } else if (match2) {
      fileId = match2[1];
    }

    return fileId
      ? `https://drive.google.com/thumbnail?id=${fileId}&sz=w2000`
      : value;
  };

  // On app initialization, fetch user details
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetchUser(token).then((userData) => {
        setCurrentUser(userData);
        setIsLoggedIn(true);
      });
    }
  }, []);

  useEffect(() => {
    fetchAppointment();
  }, [currentUser]);
  return (
    <AuthContext.Provider
      value={{
        showLoginComponent,
        showRegisterComponent,
        setShowLoginComponent,
        setShowRegisterComponent,
        isLoggedIn,
        currentUser,
        handleLoginComponent,
        handleRegisterComponent,
        login,
        logout,
        options,
        convertGoogleDriveLinkToIframe,
        covertDriveLinkToImage,
        openWhatsApp,
        makeCall,
        openGmail,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
